<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime: 2026-06-15 13:14:49
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 
 * @FilePath: \ICPSxin\src\views\platform\ICPS\smart\data.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div class="tabtop" style="width: 380px">
            <div v-for="(item, index) in contractTypelist" :key="index" @click="choose(item.status)">
              <div :class="currenindex == item.status ? 'active' : 'text'">{{ item.value }}</div>
            </div>
          </div>
          <div v-if="currenindex == 1">
            <div class="header_right" @click="showCardNav = !showCardNav">
              <div class="title">搜索</div>
              <div>
                <transition name="from"></transition>
                <span v-show="!showCardNav">
                  <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
                </span>
                <transition name="to"></transition>
                <span v-show="showCardNav">
                  <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
                </span>
              </div>
            </div>
            <div v-show="showCardNav" class="hr"></div>
            <el-collapse-transition>
              <div v-show="showCardNav">
                <div class="search">
                  <span style="display: inline-block; margin-bottom: 10px">
                    <span style="margin-right: 12px">工程名称</span>
                    <el-select ref="engineeringName" v-model="tableParam.engineeringId" placeholder="请选择" clearable filterable @change="$forceUpdate(), gettableData()">
                      <el-option v-for="(item, k) in engineeringIdList" :key="k" :label="item.engineeringName" :value="item.engineeringId"></el-option>
                    </el-select>
                  </span>
                  <span style="margin-left: 24px">
                    <span style="margin-right: 12px">产品名</span>
                    <el-input v-model="tableParam.productName" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                  </span>
                  <span style="margin-left: 24px">
                    <span style="margin-right: 12px">浇筑部位</span>
                    <el-input v-model="tableParam.structuralParts" style="width: 240px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
                  </span>
                  <span style="margin-left: 24px">
                    <span style="margin-right: 12px">状态</span>
                    <el-select v-model="tableParam.status" placeholder="请选择" clearable>
                      <el-option label="待处理" :value="1"></el-option>
                      <el-option label="已交工" :value="2"></el-option>
                      <el-option label="已排除" :value="3"></el-option>
                    </el-select>
                  </span>
                  <span style="margin-left: 24px">
                    <span style="margin-right: 12px">配合比状态</span>
                    <el-select v-model="tableParam.mixRatioDeployStatus" placeholder="请选择" clearable>
                      <el-option label="未出具" :value="1"></el-option>
                      <el-option label="已出具" :value="2"></el-option>
                    </el-select>
                  </span>
                  <span style="margin-left: 24px">
                    <span style="margin-right: 12px">站点</span>
                    <el-select v-model="tableParam.stationIdList" multiple placeholder="请选择" style="width: 120px" clearable>
                      <el-option v-for="(item, index) in stationIdList" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </span>
                  <span style="margin-left: 24px">
                    <span style="margin-right: 12px">下单时间</span>
                    <el-date-picker
                      v-model="startTimDateEndTimDate"
                      type="datetimerange"
                      unlink-panels
                      style="width: 240px"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      @change="(tableParam.startQueryTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.endQueryTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"
                    ></el-date-picker>
                  </span>
                  <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
                </div>
              </div>
            </el-collapse-transition>
            <div class="hr"></div>
            <div class="card">
              <div class="card_nav">
                <div>
                  <el-dropdown :hide-on-click="false" trigger="click">
                    <el-button size="small" class="bottom_one">添加计划</el-button>
                    <el-dropdown-menu slot="dropdown" style="text-align: left">
                      <el-dropdown-item>
                        <el-button style="margin: 5px 0" class="bottom_one" size="small" @click="productAdd()"> 生产处订单 </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button style="margin: 5px 0" class="bottom_one" size="small" @click="saleAdd()"> 销售订单 </el-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button
                    v-if="ButtonList.findIndex(res => res.buttonValue == 'DAOCJGZL') !== -1"
                    size="small"
                    class="bottom_three"
                    :disabled="
                      tableDataSelect.filter(item => {
                        return item.mixRatioDeployStatus == 2;
                      }).length == 0
                    "
                    @click="prinDeriveFun(2)"
                  >
                    <i class="iconfont iconicon_button_export1" style="font-size: 12px"></i>
                    导出开盘资料
                  </el-button>
                  <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'DAYJGZL') !== -1" size="small" class="bottom_three" :disabled="tableDataSelect.length == 0"> 打印开盘资料 </el-button>
                  <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'SHENCJGZL') !== -1" size="small" class="bottom_three" :disabled="tableDataSelect.length == 0" @click="look3Fun()"> 生成交工资料 </el-button>
                  <el-button size="small" class="bottom_three" :disabled="tableDataSelect.length == 0" @click="excluse()"> 排除 </el-button>
                </div>
                <div>
                  <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                    <el-link :underline="false">
                      <span class="el-icon--left">
                        <i class="iconfont iconicon_button_filtrate"></i>
                      </span>
                      筛选
                    </el-link>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in table" :key="index">
                        <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div v-loading="tableLoading" class="card_info" :style="style">
                <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" @selection-change="list1SelectionFun">
                  <el-table-column type="selection" width="55"> </el-table-column>
                  <template v-for="(item, index2) in table">
                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                      <template slot-scope="scope">
                        <span v-if="item.label == '产品名'">
                          <span v-if="scope.row.productDeployStatus == 1" class="table_link" style="color: red" @click="$refs.ProduceCoordinate.look1Fun(scope.row)">{{ scope.row.productName }}(待配置)</span>
                          <span v-else class="table_link" @click="$refs.ProduceCoordinate.look1Fun(scope.row)">{{ scope.row.productName }}(已配置)</span>
                        </span>
                        <span v-else-if="item.label == ' 交工订单'">
                          <span v-if="scope.row.handoverPlan == 0">否</span>
                          <span v-if="scope.row.handoverPlan == 1">是</span>
                        </span>
                        <span v-else-if="item.label == '配合比'">
                          <el-link
                            v-if="scope.row.mixRatioDeployStatus == 1"
                            style="color: red"
                            type="danger"
                            :underline="false"
                            :disabled="!(ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1)"
                            @click="$refs.ProduceCoordinate.look2Fun(scope.row, false)"
                            >未出具</el-link
                          >
                          <el-link v-else type="success" :underline="false" :disabled="!(ButtonList.findIndex(res => res.buttonValue == 'XIUGAI') !== -1)" @click="$refs.ProduceCoordinate.look2Fun(scope.row, true)">已出具</el-link>
                        </span>
                        <span v-else-if="item.label == '打印记录'">
                          <span class="table_link" @click="open('dialog1', scope.row)">查看</span>
                        </span>
                        <span v-else-if="item.label == '状态'">
                          <span v-if="scope.row.handOverStatus == 1" style="color: #969799">待处理</span>
                          <span v-if="scope.row.handOverStatus == 2" style="color: #00a754">已交工</span>
                          <span v-if="scope.row.handOverStatus == 3" style="color: #00a754">已排除</span>
                        </span>
                        <span v-else>{{ scope.row[item.prop] }}</span>
                      </template>
                    </el-table-column>
                  </template>
                </el-table>
              </div>
              <div class="card_bottom">
                <div class="card_bottom_left">
                  <div class="top_page_totle">总共{{ total }}条</div>
                  <el-pagination
                    :current-page.sync="tableParam.page"
                    :page-size="tableParam.pageSize"
                    :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
                    layout="prev,pager,sizes,next,jumper"
                    :total="total"
                    @size-change="sizeChange"
                    @current-change="gettableData()"
                  ></el-pagination>
                </div>
                <div>
                  <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
                </div>
              </div>
            </div>
          </div>
          <DataCompletionNew v-if="currenindex == 2"></DataCompletionNew>
        </div>
      </el-main>
    </el-container>
    <!-- 查看 -->
    <el-dialog v-dialogDrag :visible.sync="dialog1" width="880px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">打印及导出记录</span>
      <div class="dialogOtherinfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="table1" tooltip-effect="dark">
          <el-table-column prop="openingTime" label="序号" width="120" align="center"></el-table-column>
          <el-table-column prop="endingTime" label="记录类型" width="auto" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">打印</span>
              <span v-if="scope.row.type == 2">导出</span>
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="操作人" width="120" align="center"></el-table-column>
          <el-table-column prop="createTime" label="操作时间" width="auto" align="center"></el-table-column>
        </el-table>
        <el-pagination :current-page.sync="tableParam1.page" :page-size="tableParam1.pageSize" layout="prev, pager, next, jumper" :total="total1" @current-change="getmaintenancelist()"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog1 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 生成交工资料 -->
    <el-dialog v-dialogDrag :visible.sync="look3Type" width="600px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">生成交工资料</span>
      <div class="dialogOtherinfo">
        <el-form ref="look3form" :model="look3form" label-width="110px" :hide-required-asterisk="true">
          <el-form-item prop="stationId" :rules="[{ required: true, message: '请选择站点名称', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">站点名称</span>
            <el-select
              ref="stationName"
              v-model="look3form.stationId"
              placeholder="请选择"
              style="width: 120px"
              @change="
                $nextTick(() => {
                  look3form.stationName = $refs.stationName.getCheckedNodes()[0].label;
                })
              "
            >
              <el-option v-for="(item, index) in stationIdList" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="content" :rules="[{ required: true, message: '请输入交工资料内容', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">交工资料内容</span>
            <el-input v-model="look3form.content" placeholder="请输入" style="width: 380px"></el-input>
          </el-form-item>
          <el-form-item prop="handOverEngineeringName" :rules="[{ required: true, message: '请输入交工工程名称', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">交工工程名称</span>
            <el-input v-model="look3form.handOverEngineeringName" placeholder="请输入" style="width: 380px"></el-input>
          </el-form-item>
          <el-form-item prop="handOverRoadwork" :rules="[{ required: true, message: '请输入交工施工单位', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">交工施工单位</span>
            <el-input v-model="look3form.handOverRoadwork" placeholder="请输入" style="width: 380px"></el-input>
          </el-form-item>
          <el-form-item prop="signerId0" :rules="[{ required: true, message: '请选择签发人', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">签发人</span>
            <el-cascader
              ref="signerId0"
              v-model="look3form.signerId0"
              style="width: 380px"
              :options="signerIdList"
              :show-all-levels="false"
              :props="{ value: 'id', label: 'name' }"
              collapse-tags
              @change="
                $nextTick(() => {
                  (look3form.signer = $refs.signerId0.getCheckedNodes()[0].label),
                    (look3form.signerId = $refs.signerId0.getCheckedNodes()[0].value),
                    (look3form.signerSignature = $refs.signerId0.getCheckedNodes()[0].data.signatureImg);
                })
              "
            ></el-cascader>
          </el-form-item>
          <el-form-item prop="checkOneId0" :rules="[{ required: true, message: '请选择校核人', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">校核人</span>
            <el-cascader
              ref="checkOneId0"
              v-model="look3form.checkOneId0"
              style="width: 380px"
              :options="signerIdList"
              :show-all-levels="false"
              :props="{ value: 'id', label: 'name' }"
              collapse-tags
              @change="
                $nextTick(() => {
                  (look3form.checkOne = $refs.checkOneId0.getCheckedNodes()[0].label),
                    (look3form.checkOneId = $refs.checkOneId0.getCheckedNodes()[0].value),
                    (look3form.checkOneSignature = $refs.checkOneId0.getCheckedNodes()[0].data.signatureImg);
                })
              "
            ></el-cascader>
          </el-form-item>
          <el-form-item prop="time" :rules="[{ required: true, message: '请选择时间段', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">时间段</span>
            <el-date-picker v-model="look3form.time" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"> </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look3Type = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submit3()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导出开盘资料 -->
    <el-dialog v-dialogDrag :visible.sync="look4Type" width="600px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">导出开盘资料</span>
      <div class="dialogOtherinfo">
        <el-form ref="look4form" :model="look4form" label-width="110px" :hide-required-asterisk="true">
          <el-form-item prop="inspectorSignatureList" :rules="[{ required: true, message: '请选择检测人', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">检测人</span>
            <el-select v-model="look4form.inspectorSignatureList" multiple placeholder="请选择" style="width: 380px" filterable>
              <el-option v-for="(item, index) in userList" :key="index" :label="item.name + '_' + item.company" :value="item.name"> </el-option>
            </el-select>
            <!-- <el-cascader
              ref="inspectorSignatureList"
              v-model="look4form.inspectorSignatureList"
              style="width: 380px"
              :options="signerIdList"
              :show-all-levels="false"
              :props="{ value: 'name', label: 'name', multiple:true, emitPath:false }"
            ></el-cascader> -->
          </el-form-item>
          <el-form-item prop="signerId0" :rules="[{ required: true, message: '请选择签发人', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">签发人</span>
            <el-select v-model="look4form.signerId0" placeholder="请选择" style="width: 380px" filterable>
              <el-option 
                v-for="item in userList" 
                :key="item.id" 
                :label="item.name + '_' + item.company" 
                :value="item.id" 
                @click.native="setSignature(item)">
              </el-option>
            </el-select>
            <!-- <el-input v-model="look4form.signerId01" style="width: 380px" clearable placeholder="请输入" disabled /> -->
            <!-- <el-select v-model="look4form.signerId0" placeholder="请选择"  style="width: 380px" filterable>
                <el-option v-for="(item,index) in userList" :key="index" :label="item.name+'_'+item.company" :value="[item.id]" @click.native="setSignature(item)">
              </el-option>
            </el-select> -->
            <!-- <el-cascader
              ref="signerId0"
              v-model="look4form.signerId0"
              style="width: 380px"
              :options="signerIdList"
              :show-all-levels="false"
              :props="{ value: 'id', label: 'name' }"
              collapse-tags
              @change="
                $nextTick(() => {
                  look4form.signerSignature = $refs.signerId0.getCheckedNodes()[0].data.signatureImg;
                })
              "
            ></el-cascader> -->
          </el-form-item>
          <el-form-item prop="checkOneId0" :rules="[{ required: true, message: '请选择校核人', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">校核人</span>
            <el-select v-model="look4form.checkOneId0" placeholder="请选择" style="width: 380px" filterable>
              <el-option 
                v-for="item in userList" 
                :key="item.id" 
                :label="item.name + '_' + item.company" 
                :value="item.id" 
                @click.native="setCheckOneSignature(item)">
              </el-option>
            </el-select>
            <!-- <el-input v-model="look4form.checkOneId01" style="width: 380px" clearable placeholder="请输入" disabled /> -->
            <!-- <el-select v-model="look4form.checkOneId0" placeholder="请选择"  style="width: 380px"  filterable>
                <el-option v-for="(item,index) in userList" :key="index" :label="item.name+'_'+item.company" :value="[item.id]" @click.native="setCheckOneSignature(item)">
              </el-option>
            </el-select> -->
            <!-- <el-cascader
              ref="checkOneId0"
              v-model="look4form.checkOneId0"
              style="width: 380px"
              :options="signerIdList"
              :show-all-levels="false"
              :props="{ value: 'id', label: 'name' }"
              collapse-tags
              @change="
                $nextTick(() => {
                  look4form.checkOneSignature = $refs.checkOneId0.getCheckedNodes()[0].data.signatureImg;
                })
              "
            ></el-cascader> -->
          </el-form-item>
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="look4Table" tooltip-effect="dark">
            <el-table-column width="auto" label="原物料名称" prop="rawName"> </el-table-column>
            <el-table-column width="auto" label="厂家材质报告">
              <template slot-scope="scope">
                <span v-if="scope.row.cjcz" class="table_link" style="cursor: pointer" @click="choiceReport(scope.$index, 1, '厂家材质报告')">{{ scope.row.cjczName }}</span>
                <span v-else class="table_link" style="cursor: pointer" @click="choiceReport(scope.$index, 1, '厂家材质报告')">选择</span></template
              >
            </el-table-column>
            <el-table-column width="auto" label="合格证">
              <template slot-scope="scope">
                <span v-if="scope.row.hgz" class="table_link" style="cursor: pointer" @click="choiceReport(scope.$index, 2, '合格证')">{{ scope.row.hgzName }}</span>
                <span v-else class="table_link" style="cursor: pointer" @click="choiceReport(scope.$index, 2, '合格证')">选择</span></template
              >
            </el-table-column>
            <el-table-column width="auto" label="第三方报告">
              <template slot-scope="scope">
                <span v-if="scope.row.dsf" class="table_link" style="cursor: pointer" @click="choiceReport(scope.$index, 3, '第三方报告')">{{ scope.row.dsfName }}</span>
                <span v-else class="table_link" style="cursor: pointer" @click="choiceReport(scope.$index, 3, '第三方报告')">选择</span></template
              >
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="look4Type = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submit4()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加计划-销售处订单 -->
    <el-dialog v-dialogDrag :visible.sync="addDialogSale" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">添加计划</span>
      <div class="dialoginfo">
        <el-form ref="reffromDataSale" :rules="saleRules" :inline="true" :model="formDataSale" label-width="110px">
          <el-form-item>
            <span slot="label">工程名称</span>
            <el-select ref="engineeringName" v-model="formDataSale.engineeringId" placeholder="请选择" clearable filterable @change="getDisClost()">
              <el-option v-for="(item, k) in saleEngineeringList" :key="k" :label="item.name" :value="item.id" @click.native="formDataSale.engineeringName = item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="structuralParts">
            <span slot="label">浇筑部位</span>
            <el-select v-model="formDataSale.structuralParts" filterable allow-create default-first-option placeholder="请选择" @change="structuralPartsCheckFun()">
              <el-option v-for="item in structuralPartsList" :key="item.id" :label="item.structuralParts + (item.used == 1 ? '-已选择' : '-未选择')" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="strengthGradeId" label="强度等级" :rules="[{ required: true, message: '请选择强度等级', trigger: 'change' }]">
            <el-select v-model="formDataSale.strengthGradeId" placeholder="请选择" filterable>
              <el-option v-for="item in strengthGradeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">性能等级</span>
            <el-select v-model="formDataSale.performanceGradeIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in performanceGradeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">材料要求</span>
            <el-select v-model="formDataSale.meterialRequirementsIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in meterialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">特殊要求</span>
            <el-select v-model="formDataSale.specialRequirementsIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in specialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">其他要求</span>
            <el-select v-model="formDataSale.otherRequirementsIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in otherRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">外加剂要求</span>
            <el-select v-model="formDataSale.admixtureRequirementsIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in admixtureRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="pouringMethodIdList" :rules="[{ required: true, message: '请选择浇筑方式', trigger: 'change' }]">
            <span slot="label">浇筑方式</span>
            <el-select v-model="formDataSale.pouringMethodIdList" multiple placeholder="请选择">
              <el-option v-for="item in pouringMethodList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="pouringTime">
            <span slot="label">浇筑时间</span>
            <el-date-picker
              v-model="formDataSale.pouringTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择"
              :picker-options="{
                step: '10:00',
              }"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <span slot="label">是否超高层</span>
            <el-select v-model="formDataSale.supperHighLayer" placeholder="请选择" filterable @change="typeChange">
              <el-option v-for="item in supperHighLayerList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="pouringHigh">
            <span slot="label">泵送高度</span>
            <el-input v-model="formDataSale.pouringHigh" placeholder="请输入">
              <span slot="suffix">米</span>
            </el-input>
          </el-form-item>
          <el-form-item prop="pouringNum" :rules="[{ required: true, message: '请输入浇筑用量', trigger: 'change' }]">
            <span slot="label">浇筑用量</span>
            <el-input v-model="formDataSale.pouringNum" v-input-limit="value => (String(value || '').match(/\d{1,8}(\.\d{1}|\.)?/) ? String(value || '').match(/\d{1,8}(\.\d{1}|\.)?/)[0] : '')" placeholder="请输入">
              <span slot="suffix"> m³</span>
            </el-input>
          </el-form-item>
          <el-form-item prop="person">
            <span slot="label">联系人</span>
            <el-input v-model="formDataSale.person" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="phoneNum">
            <span slot="label">联系电话</span>
            <el-input v-model="formDataSale.phoneNum" type="Number" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="structureSize">
            <span slot="label">订单备注</span>
            <el-input v-model="formDataSale.orderRemark" :rows="5" resize="none" style="width: 760px" type="textarea" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="pointId">
            <span slot="label">供应站点</span>
            <el-select
              ref="addpoint"
              v-model="formDataSale.pointId"
              placeholder="请选择"
              @change="
                $forceUpdate();
                $nextTick(() => {
                  formDataSale.pointName = $refs.addpoint.selectedLabel;
                });
              "
            >
              <el-option v-for="(v, k) in stationIdList" :key="k" :label="v.name" :value="v.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="settleId">
            <span slot="label">结算方式</span>
            <el-select
              ref="addsettle"
              v-model="formDataSale.settleId"
              placeholder="请选择"
              @change="
                $forceUpdate();
                $nextTick(() => {
                  formDataSale.settleName = $refs.addsettle.selectedLabel;
                });
              "
            >
              <el-option label="双控" value="0"></el-option>
              <el-option label="图结" value="1"></el-option>
              <el-option label="实结" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="formDataSale.settleId != '2'" prop="graphicNum">
            <span slot="label">图算量</span>
            <el-input v-model="formDataSale.graphicNum" placeholder="请输入"> </el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">富余量</span>
            <el-select
              ref="addlossNum"
              v-model="formDataSale.lossNumId"
              placeholder="请选择"
              @change="
                $forceUpdate();
                $nextTick(() => {
                  formDataSale.lossNum = $refs.addlossNum.selectedLabel;
                });
              "
            >
              <el-option v-for="(v, k) in marginNumberList" :key="k" :label="v.itemName" :value="v.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">增值服务项</span>
            <div style="width: 660px; height: 36px">{{ servicePoint }}</div>
          </el-form-item>
          <el-form-item>
            <el-button class="bottom_two" @click="choiseBussinessPoint()">更改</el-button>
          </el-form-item>
          <el-form-item>
            <span slot="label">内部备注</span>
            <el-input v-model="formDataSale.remark" :rows="1" resize="none" style="width: 760px" type="textarea" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addDialogSale = false">取 消</el-button>
        <!-- <el-button class="bottom_all" :disabled="buttonType" style="margin-left: 24px;" @click="submit()">确 定</el-button> -->
        <el-button class="bottom_all" :disabled="buttonType" style="margin-left: 24px" @click="addSaleCost()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 添加计划-生产处订单 -->
    <el-dialog v-dialogDrag :visible.sync="addDialogProduct" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">添加计划</span>
      <div class="dialoginfo">
        <el-form ref="reffromDataProduct" :rules="productRules" :inline="true" :model="formDataProduct" label-width="110px">
          <el-form-item prop="stationId">
            <span slot="label">供应站点</span>
            <el-select
              ref="addpoint"
              v-model="formDataProduct.stationId"
              placeholder="请选择"
              @change="
                $forceUpdate();
                $nextTick(() => {
                  formDataProduct.stationName = $refs.addpoint.selectedLabel;
                });
              "
            >
              <el-option v-for="(v, k) in stationIdList" :key="k" :label="v.name" :value="v.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="engineeringId">
            <span slot="label">工程名称</span>
            <el-select
              ref="engineeringName"
              v-model="formDataProduct.engineeringId"
              placeholder="请选择"
              clearable
              filterable
              @change="
                $nextTick(
                  () => {
                    formDataProduct.engineeringName = $refs.engineeringName.selectedLabel;
                  },
                  addDialogFun(),
                  getListsFun()
                )
              "
            >
              <el-option
                v-for="(item, k) in productEngineeringList"
                :key="k"
                :label="item.name"
                :value="item.id"
                @click.native="(formDataProduct.engineeringName = item.name), (formDataProduct.engineeringId = item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="structuralParts" :rules="[{ required: true, message: '请输入浇筑部位', trigger: 'change' }]">
            <span slot="label">浇筑部位</span>
            <el-select v-model="formDataProduct.structuralParts" filterable allow-create default-first-option placeholder="请选择" @change="structuralPartsCheckFun()">
              <el-option v-for="item in structuralPartsList" :key="item.id" :label="item.structuralParts + (item.used == 1 ? '-已选择' : '-未选择')" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="strengthGradeId" label="强度等级" :rules="[{ required: true, message: '请选择强度等级', trigger: 'change' }]">
            <el-select v-model="formDataProduct.strengthGradeId" placeholder="请选择" filterable>
              <el-option v-for="item in strengthGradeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">性能等级</span>
            <el-select v-model="formDataProduct.performanceGradeIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in performanceGradeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">材料要求</span>
            <el-select v-model="formDataProduct.meterialRequirementsIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in meterialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">特殊要求</span>
            <el-select v-model="formDataProduct.specialRequirementsIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in specialRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">其他要求</span>
            <el-select v-model="formDataProduct.otherRequirementsIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in otherRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label">外加剂要求</span>
            <el-select v-model="formDataProduct.admixtureRequirementsIdList" multiple placeholder="请选择" filterable>
              <el-option v-for="item in admixtureRequirementsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="pouringMethodIdList">
            <span slot="label">浇筑方式</span>
            <el-select v-model="formDataProduct.pouringMethodIdList" multiple placeholder="请选择">
              <el-option v-for="item in pouringMethodList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="pouringTime">
            <span slot="label">浇筑时间</span>
            <el-date-picker
              v-model="formDataProduct.pouringTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择"
              :picker-options="{
                step: '10:00',
              }"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="pouringHigh">
            <span slot="label">泵送高度</span>
            <el-input v-model="formDataProduct.pouringHigh" placeholder="请输入">
              <span slot="suffix">米</span>
            </el-input>
          </el-form-item>
          <el-form-item prop="pouringNum" :rules="[{ required: true, message: '请输入浇筑用量', trigger: 'change' }]">
            <span slot="label">浇筑用量</span>
            <el-input v-model="formDataProduct.pouringNum" v-input-limit="value => (String(value || '').match(/\d{1,8}(\.\d{1}|\.)?/) ? String(value || '').match(/\d{1,8}(\.\d{1}|\.)?/)[0] : '')" placeholder="请输入">
              <span slot="suffix"> m³</span>
            </el-input>
          </el-form-item>
          <el-form-item prop="person">
            <span slot="label">联系人</span>
            <el-input v-model="formDataProduct.person" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="phoneNum">
            <span slot="label">联系电话</span>
            <el-input v-model="formDataProduct.phoneNum" type="Number" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">备注</span>
            <el-input v-model="formDataProduct.remark" :rows="1" resize="none" style="width: 760px" type="textarea" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="addDialogProduct = false">取 消</el-button>
        <!-- <el-button class="bottom_all" :disabled="buttonType" style="margin-left: 24px;" @click="submit()">确 定</el-button> -->
        <el-button class="bottom_all" :disabled="buttonType" style="margin-left: 24px" @click="addProductCost()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 管控业务点 -->
    <el-dialog v-dialogDrag :visible.sync="bussinessVisible" width="60%">
      <span slot="title" class="dialog-title">管控业务点</span>
      <el-checkbox-group v-model="buspointids">
        <template v-for="(item, index) in buspointArr">
          <div :key="index" class="checkbox-bg">
            <el-checkbox :label="item.id">{{ item.itemName }}</el-checkbox>
          </div>
        </template>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="bussinessVisible = false">关 闭</el-button>
        <el-button class="bottom_all" @click="handlePoint">确 定</el-button>
      </span>
    </el-dialog>

    <ProduceCoordinate ref="ProduceCoordinate" :status="1" @reload="reload"></ProduceCoordinate>
    <ReportDig ref="ReportDig" :reportDig.sync="reportDig" @confirmReport="confirmReport" @colseReprotDig="reportDig = false"></ReportDig>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryPage,
  batchUpdateOrDelete,
  updateSortNum,
  saveOrUpdate,
  Download,
  signOfPrintLog,
  // signOfPrintLogSave,
  queryEngineeringList,
  handOverInformationsaveResord,
  exportTende,
  batchExclude,
  getRawName,
  querySaleEngList,
  saveSaleHnadoverPlan,
  queryProduceEngList,
  saveProduceHnadoverPlan,
} from "@/api/smart/data.js";
import produceCoordinate from "./components_data/produce_coordinate"; //引入产品名和配合比的内容组件
import dataCompletionNew from "./components_data/dataCompletionNew"; //引入交工资料
import reportDig from "./components_data/reportDig"; //引入报告选择弹窗
import { getUserAutList, orgUserTree, getDicType } from "@/api/common.js";
import { getUserInfoList } from "@/api/basedata/user.js";
import { getUserInfo } from "@/utils/auth.js";
import { getDisClostDetail } from "@/api/internetSales/projectClarifi.js";
import { graphic_list } from "@/api/smart/schedul/b.js";
import { getLists } from "@/api/smart/schedul/c.js";
import moment from "moment";
export default {
  components: {
    //启动组件
    ProduceCoordinate: produceCoordinate,
    DataCompletionNew: dataCompletionNew,
    ReportDig: reportDig,
  },
  mixins: [mixin],
  data() {
    return {
      userList: [],
      startTimDateEndTimDate: [],
      exportTende: exportTende,
      engineeringIdList: [],
      currenindex: 1,
      contractTypelist: [
        {
          value: "配置列表",
          status: 1,
        },
        {
          value: "交工资料",
          status: 2,
        },
      ],
      UserInfo: "",
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      batchUpdateOrDelete: batchUpdateOrDelete,
      updateSortNum: updateSortNum,
      saveOrUpdate: saveOrUpdate,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "订单编号", width: "auto", prop: "orderNo", status: true },
        { label: "工程名称", width: "120", prop: "engineeringName", status: true },
        { label: "工程地址", width: "auto", prop: "place", status: true },
        { label: "生产站点", width: "auto", prop: "stationName", status: true },
        { label: "施工单位", width: "120", prop: "roadwork", status: true },
        { label: "浇筑部位", width: "120", prop: "structuralParts", status: true },
        { label: "交工订单", width: "120", prop: "handoverPlan", status: true },
        { label: "产品名", width: "160", prop: "productName", status: true },
        { label: "配合比", width: "80", prop: "", status: true },
        { label: "交工配合比编号", width: "120", prop: "mixRatioNumber", status: true },
        { label: "下单时间", width: "120", prop: "createTime", status: true },
        { label: "报告时间", width: "120", prop: "reportTime", status: true },
        { label: "浇筑时间", width: "160", prop: "pouringTime", status: true },
        { label: "状态", width: "120", prop: "", status: true },
        { label: "打印记录", width: "120", prop: "", status: true },
      ],
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        code: [{ required: true, message: "请输入站点编码", trigger: "blur" }],
      },
      fromDate: {
        code: "",
      },
      /*查看*/
      dialog1: false,
      table1: [],
      tableParam1: {
        page: 1,
        pageSize: 10,
      },
      total1: 0,
      form3: [],
      table2: [],
      /*配合比*/
      dialog3: false,
      tableParam3: {
        page: 1,
        pageSize: 10,
      },
      total3: 0,
      tableDataSelect: [],
      look3Type: false,
      look3form: {
        stationId0: [],
        signerId0: [],
        checkOneId0: [],
      },
      look4Type: false,
      look4Table: [],
      look4form: {
        stationId0: [],
        signerId0: [],
        checkOneId0: [],
        signerSignature: "",
        checkOneSignature: "",
        inspectorSignatureList: [],
      },
      stationIdList: [],
      signerIdList: [],
      checkOneIdList: [],
      idList: [],
      reportDig: false,
      reportIndex: "",
      reportType: 1,
      addDialogSale: false,
      addDialogProduct: false,
      formDataSale: {
        strengthGradeId: "", //强度等级
        performanceGradeIdList: [],
        meterialRequirementsIdList: [],
        specialRequirementsIdList: [],
        otherRequirementsIdList: [],
        admixtureRequirementsIdList: [],
        pouringMethodIdList: [],
        pouringTime: "", //浇筑时间
        graphicNum: "",
        pouringHigh: "",
        pouringNum: "",
        person: "",
        phoneNum: "",
        remark: "",
        structuralParts: "",
      },
      formDataProduct: {
        strengthGradeId: "", //强度等级
        performanceGradeIdList: [],
        meterialRequirementsIdList: [],
        specialRequirementsIdList: [],
        otherRequirementsIdList: [],
        admixtureRequirementsIdList: [],
        pouringMethodIdList: [],
        pouringTime: "", //浇筑时间
        graphicNum: "",
        pouringHigh: "",
        pouringNum: "",
        person: "",
        phoneNum: "",
        remark: "",
        structuralParts: "",
        stationId: "",
        engineeringId: "",
      },
      productEngineeringList: [],
      saleEngineeringList: [],
      strengthGradeList: [], //强度list
      performanceGradeList: [], //性能等级list
      meterialRequirementsList: [], //材料要求list
      specialRequirementsList: [], //特殊要求list
      otherRequirementsList: [], //其他要求list
      admixtureRequirementsList: [], //外加剂要求list
      pouringMethodList: [], //浇筑方式list
      structuralPartsList: [], //浇筑部位
      marginNumberList: [],
      supperHighLayerList: [
        { value: 1, label: "是" },
        { value: 0, label: "否" },
      ],
      detailData: {},
      bussinessVisible: false,
      buttonType: false,
      buspointArr: [],
      slumpArr: [],
      servicePoint: "",
      buspointids: [],
      pouringHigh: {
        required: true,
        message: "请输入泵送高度",
        trigger: "change",
      },
      saleRules: {
        structuralParts: [
          {
            required: true,
            message: "请输入浇筑部位",
            trigger: "change",
          },
        ],
        pouringTime: [
          {
            required: true,
            message: "请选择浇筑时间",
            trigger: "change",
          },
        ],
        graphicNum: [
          {
            required: true,
            message: "请输入图算量",
            trigger: "blur",
          },
        ],
        pouringHigh: [],
        person: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "change",
          },
        ],
        phoneNum: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "change",
          },
          { min: 11, max: 11, message: "手机号格式错误", trigger: "change" },
        ],
      },
      productRules: {
        stationId: [
          {
            required: true,
            message: "请选择站点",
            trigger: "change",
          },
        ],
        engineeringId: [
          {
            required: true,
            message: "请选择工程",
            trigger: "change",
          },
        ],
        pouringTime: [
          {
            required: true,
            message: "请选择浇筑时间",
            trigger: "change",
          },
        ],
        strengthGradeId: [
          {
            required: true,
            message: "请选择强度等级",
            trigger: "change",
          },
        ],
        pouringMethodIdList: [
          {
            required: true,
            message: "请选择浇筑方式",
            trigger: "change",
          },
        ],
        pouringNum: [
          {
            required: true,
            message: "请输入浇筑用量",
            trigger: "change",
          },
        ],
        person: [
          {
            required: true,
            message: "请输入联系人",
            trigger: "change",
          },
        ],
        phoneNum: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "change",
          },
          { min: 11, max: 11, message: "手机号格式错误", trigger: "change" },
        ],
      },
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam, productName: "", status: "", stationIdList: [], mixRatioDeployStatus: "", engineeringId: "", structuralParts: "" };
    const today = moment().add(1, "days").format("YYYY-MM-DD 00:00:00"); //当前日期
    const weekBefore = moment().subtract(7, "days").format("YYYY-MM-DD 00:00:00"); // 近七日日期
    this.tableParam.startQueryTime = weekBefore;
    this.tableParam.endQueryTime = today;
    this.startTimDateEndTimDate = [weekBefore, today];
    getDicType({
      code: "market",
    }).then(res => {
      this.buspointArr = res.data.items;
    });
    getDicType({
      code: "marginNumber",
    }).then(res => {
      this.marginNumberList = res.data.items;
    });
    querySaleEngList().then(res => {
      this.saleEngineeringList = res.data;
    });
    queryProduceEngList().then(res => {
      this.productEngineeringList = res.data;
    });
    getUserInfoList().then(res => {
      this.userList = res.data;
    });
    this.stationIdList = await getUserAutList(true);
    //获取当前账号公司id的组织树
    this.signerIdList = await orgUserTree(this.UserInfo.companyId);
  },
  methods: {
    //生产处订单 --开始 --
    //查询数据字典
    getListsFun() {
      getLists().then(res => {
        res.data.forEach(item => {
          if (!item) return;
          if (item.typeName == "强度等级") {
            this.strengthGradeList = item.list;
          } else if (item.typeName == "规范性能等级") {
            this.performanceGradeList = item.list;
          } else if (item.typeName == "材料要求") {
            this.meterialRequirementsList = item.list;
          } else if (item.typeName == "特殊要求") {
            this.specialRequirementsList = item.list;
          } else if (item.typeName == "外加剂要求") {
            this.admixtureRequirementsList = item.list;
          } else if (item.typeName == "其他要求") {
            this.otherRequirementsList = item.list;
          }
        });
        /**浇筑方式泵机类型  往来协作 取合同 其他取数据字典*/
        this.pouringMethodList = [];
        let pouringMethodList1 = [];
        let pouringMethodList2 = [];
        getDicType({
          code: "pouringMethod",
        }).then(res => {
          // res.data.items.map(v1 => (v1.type = 1));
          pouringMethodList1 = res.data.items;
          pouringMethodList1.forEach(res => {
            res.name = res.itemName;
          });
          this.pouringMethodList = [...this.pouringMethodList, ...pouringMethodList1];
        });
        getDicType({
          code: "castingType",
        }).then(res => {
          // res.data.items.map(v1 => (v1.type = 1));
          pouringMethodList2 = res.data.items;
          pouringMethodList2.forEach(res => {
            res.name = res.itemName;
          });
          this.pouringMethodList = [...this.pouringMethodList, ...pouringMethodList2];
        });
      });
    },
    /**工程选择后查询浇筑部位 */
    addDialogFun() {
      console.log(11);
      let day3 = new Date();
      day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000);
      var s3 = day3.getFullYear() + "-" + (day3.getMonth() + 1) + "-" + day3.getDate();
      this.formDataProduct.pouringTime = new Date(s3).Format("yyyy-MM-dd") + " 08:00:00";
      this.formDataProduct.engineeringName = this.engineeringName;
      graphic_list({ engineeringId: this.formDataProduct.engineeringId }).then(res => {
        this.structuralPartsList = res.data;
      });
    },
    //保存
    addProductCost() {
      this.$refs.reffromDataProduct.validate(valid => {
        if (valid) {
          this.formDataProduct.strengthGrade = this.$fromatTable(this.strengthGradeList, this.formDataProduct.strengthGradeId, "id", "name");
          //性能等级-开始数据重装
          if (this.formDataProduct.performanceGradeIdList.length > 0) {
            let arr = [];
            this.formDataProduct.performanceGradeIdList.forEach(v => {
              this.performanceGradeList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataProduct.performanceGradeId = arr;
            this.formDataProduct.performanceGradeId = JSON.stringify(this.formDataProduct.performanceGradeId);
            this.formDataProduct.performanceGrade = this.formDataProduct.performanceGradeId;
          }
          //材料要求-开始数据重装
          if (this.formDataProduct.meterialRequirementsIdList.length > 0) {
            let arr = [];
            this.formDataProduct.meterialRequirementsIdList.forEach(v => {
              this.meterialRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataProduct.meterialRequirementsId = arr;
            this.formDataProduct.meterialRequirementsId = JSON.stringify(this.formDataProduct.meterialRequirementsId);
            this.formDataProduct.meterialRequirements = this.formDataProduct.meterialRequirementsId;
          }
          //特殊要求-开始数据重装
          if (this.formDataProduct.specialRequirementsIdList.length > 0) {
            let arr = [];
            this.formDataProduct.specialRequirementsIdList.forEach(v => {
              this.specialRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataProduct.specialRequirementsId = arr;
            this.formDataProduct.specialRequirementsId = JSON.stringify(this.formDataProduct.specialRequirementsId);
            this.formDataProduct.specialRequirements = this.formDataProduct.specialRequirementsId;
          }
          //其他要求-开始数据重装
          if (this.formDataProduct.otherRequirementsIdList.length > 0) {
            let arr = [];
            this.formDataProduct.otherRequirementsIdList.forEach(v => {
              this.otherRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataProduct.otherRequirementsId = arr;
            this.formDataProduct.otherRequirementsId = JSON.stringify(this.formDataProduct.otherRequirementsId);
            this.formDataProduct.otherRequirements = this.formDataProduct.otherRequirementsId;
          }
          //外加剂要求-开始数据重装
          if (this.formDataProduct.admixtureRequirementsIdList.length > 0) {
            let arr = [];
            this.formDataProduct.admixtureRequirementsIdList.forEach(v => {
              this.admixtureRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataProduct.admixtureRequirements = arr;
            this.formDataProduct.admixtureRequirements = JSON.stringify(this.formDataProduct.admixtureRequirements);
          }
          //浇筑方式-开始数据重装
          if (this.formDataProduct.pouringMethodIdList.length > 0) {
            let arr = [];
            this.formDataProduct.pouringMethodIdList.forEach(v => {
              this.pouringMethodList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                    type: v2.type,
                  });
                }
              });
            });
            this.formDataProduct.pouringMethod = arr;
          }
          this.formDataProduct.pouringMethod = JSON.stringify(this.formDataProduct.pouringMethod);
          this.structuralPartsFun();
          this.buttonType = true;
          saveProduceHnadoverPlan(this.formDataProduct)
            .then(res => {
              if (res.code == 1001) {
                this.$message.success("保存成功!");
                this.addDialogProduct = false;
                this.gettableData();
              }
              this.buttonType = false;
            })
            .catch(() => {
              this.buttonType = false;
            });
        } else {
          return false;
        }
      });
    },
    productAdd() {
      this.addDialogProduct = true;
      this.formDataProduct = this.$options.data().formDataProduct;
      setTimeout(() => {
        this.$refs.reffromDataProduct.resetFields();
      }, 100);
    },
    //生产处订单 --结束 --
    //销售订单 --开始 --
    typeChange(val) {
      if (val == 0) {
        this.$set(this.saleRules.pouringHigh, 0, "");
      } else {
        //开启校验
        this.$set(this.saleRules.pouringHigh, 0, this.pouringHigh);
      }
    },
    structuralPartsCheckFun() {
      this.formDataSale.strengthGradeId = "";
      this.formDataSale.performanceGradeIdList = "";
      this.formDataSale.meterialRequirementsIdList = "";
      this.formDataSale.specialRequirementsIdList = "";
      this.formDataSale.otherRequirementsIdList = "";
      this.formDataSale.admixtureRequirementsIdList = "";
      let item = this.structuralPartsList.find(v => v.id == this.formDataSale.structuralParts);
      if (item) {
        this.formDataSale.strengthGradeId = JSON.parse(item.strengthGrade)[0].id;
        if (item.performanceGrade) {
          this.formDataSale.performanceGradeIdList = JSON.parse(item.performanceGrade).map(v => v.id);
        }
        if (item.meterialRequirements) {
          this.formDataSale.meterialRequirementsIdList = JSON.parse(item.meterialRequirements).map(v => v.id);
        }
        if (item.specialRequirements) {
          this.formDataSale.specialRequirementsIdList = JSON.parse(item.specialRequirements).map(v => v.id);
        }
        if (item.otherRequirements) {
          this.formDataSale.otherRequirementsIdList = JSON.parse(item.otherRequirements).map(v => v.id);
        }
        if (item.admixtureRequirements) {
          this.formDataSale.admixtureRequirementsIdList = JSON.parse(item.admixtureRequirements).map(v => v.id);
        }
      }
    },
    addSaleCost() {
      this.$refs.reffromDataSale.validate(valid => {
        if (valid) {
          this.formDataSale.strengthGrade = this.$fromatTable(this.strengthGradeList, this.formDataSale.strengthGradeId, "id", "name");
          //性能等级-开始数据重装
          if (this.formDataSale.performanceGradeIdList.length > 0) {
            let arr = [];
            this.formDataSale.performanceGradeIdList.forEach(v => {
              this.performanceGradeList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataSale.performanceGradeId = arr;
            this.formDataSale.performanceGradeId = JSON.stringify(this.formDataSale.performanceGradeId);
            this.formDataSale.performanceGrade = this.formDataSale.performanceGradeId;
          }
          //材料要求-开始数据重装
          if (this.formDataSale.meterialRequirementsIdList.length > 0) {
            let arr = [];
            this.formDataSale.meterialRequirementsIdList.forEach(v => {
              this.meterialRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataSale.meterialRequirementsId = arr;
            this.formDataSale.meterialRequirementsId = JSON.stringify(this.formDataSale.meterialRequirementsId);
            this.formDataSale.meterialRequirements = this.formDataSale.meterialRequirementsId;
          }
          //特殊要求-开始数据重装
          if (this.formDataSale.specialRequirementsIdList.length > 0) {
            let arr = [];
            this.formDataSale.specialRequirementsIdList.forEach(v => {
              this.specialRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataSale.specialRequirementsId = arr;
            this.formDataSale.specialRequirementsId = JSON.stringify(this.formDataSale.specialRequirementsId);
            this.formDataSale.specialRequirements = this.formDataSale.specialRequirementsId;
          }
          //其他要求-开始数据重装
          if (this.formDataSale.otherRequirementsIdList.length > 0) {
            let arr = [];
            this.formDataSale.otherRequirementsIdList.forEach(v => {
              this.otherRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataSale.otherRequirementsId = arr;
            this.formDataSale.otherRequirementsId = JSON.stringify(this.formDataSale.otherRequirementsId);
            this.formDataSale.otherRequirements = this.formDataSale.otherRequirementsId;
          }
          //外加剂要求-开始数据重装
          if (this.formDataSale.admixtureRequirementsIdList.length > 0) {
            let arr = [];
            this.formDataSale.admixtureRequirementsIdList.forEach(v => {
              this.admixtureRequirementsList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                  });
                }
              });
            });
            this.formDataSale.admixtureRequirements = arr;
            this.formDataSale.admixtureRequirements = JSON.stringify(this.formDataSale.admixtureRequirements);
          }
          //浇筑方式-开始数据重装
          if (this.formDataSale.pouringMethodIdList.length > 0) {
            let arr = [];
            this.formDataSale.pouringMethodIdList.forEach(v => {
              this.pouringMethodList.forEach(v2 => {
                if (v == v2.id) {
                  arr.push({
                    id: v,
                    name: v2.name,
                    type: v2.type,
                  });
                }
              });
            });
            this.formDataSale.pouringMethod = arr;
          }
          this.formDataSale.pouringMethod = JSON.stringify(this.formDataSale.pouringMethod);
          this.structuralPartsFun();
          this.formDataSale.engineeringId = this.detailData.engineeringId;
          this.buttonType = true;
          saveSaleHnadoverPlan(this.formDataSale)
            .then(res => {
              if (res.code == 1001) {
                this.$message.success("保存成功!");
                this.addDialogSale = false;
                this.gettableData();
              }
              this.buttonType = false;
            })
            .catch(() => {
              this.buttonType = false;
            });
        } else {
          return false;
        }
      });
    },
    structuralPartsFun() {
      let item = this.structuralPartsList.find(v => v.id == this.formDataSale.structuralParts);
      if (item) {
        this.formDataSale.structuralPartsId = this.formDataSale.structuralParts;
        this.formDataSale.structuralParts = item.structuralParts;
      } else {
        this.formDataSale.structuralPartsId = "";
      }
    },
    handlePoint() {
      const newData = this.buspointArr.filter(item => this.buspointids.some(items => item.id === items));
      this.servicePoint = newData.map(item => item.itemName).join(",");
      this.formDataSale.servicePoint = JSON.stringify(newData.map(item => ({ id: item.id, name: item.itemName, type: 1 })));
      this.bussinessVisible = false;
    },
    /**
     * @Description: 选择管控业务点
     */
    choiseBussinessPoint() {
      this.bussinessVisible = true;
    },
    //根据选择的工程获取浇筑部位 强度等级+各项要求+浇筑部位
    async getDisClost() {
      graphic_list({ engineeringId: this.formDataSale.engineeringId }).then(res => {
        this.structuralPartsList = res.data;
      });
      getDisClostDetail({ id: this.formDataSale.engineeringId }).then(res => {
        if (res.code === 1001) {
          this.strengthGradeList = JSON.parse(res.data.strengthGrade);
          this.performanceGradeList = JSON.parse(res.data.performanceRate);
          //材料要求pouringMethodList
          this.meterialRequirementsList = JSON.parse(res.data.materialRequirements);
          //特殊要求
          this.specialRequirementsList = JSON.parse(res.data.specialRequirements);
          //外加剂要求
          this.admixtureRequirementsList = JSON.parse(res.data.admixtureRequirements);
          //其他要求
          this.otherRequirementsList = JSON.parse(res.data.otherRequirements);
          //浇筑方式
          this.pouringMethodList = JSON.parse(res.data.pumpType);

          this.detailData = res.data;
          this.formDataSale.pointId = this.detailData.mainSupplySiteId; // 默认站点ID
          this.formDataSale.pointName = this.detailData.mainSupplySite; // 默认站点名称
          this.formDataSale.servicePoint = this.detailData.servicePoint; // 默认增值服务项
          this.servicePoint = JSON.parse(this.detailData.servicePoint)
            .map(item => item.name)
            .join(",");
          this.buspointids = JSON.parse(this.detailData.servicePoint).map(item => item.id);
        }
      });
    },
    /**查询该工程的强度等级+各项要求+浇筑部位 */
    getDisClostDisAddCostFun(id) {
      getDisClostDetail({ id }).then(res => {
        if (res.code === 1001) {
          this.strengthGradeList = JSON.parse(res.data.strengthGrade);
          this.performanceGradeList = JSON.parse(res.data.performanceRate);
          //材料要求pouringMethodList
          this.meterialRequirementsList = JSON.parse(res.data.materialRequirements);
          //特殊要求
          this.specialRequirementsList = JSON.parse(res.data.specialRequirements);
          //外加剂要求
          this.admixtureRequirementsList = JSON.parse(res.data.admixtureRequirements);
          //其他要求
          this.otherRequirementsList = JSON.parse(res.data.otherRequirements);
          //浇筑方式
          this.pouringMethodList = JSON.parse(res.data.pumpType);

          this.detailData = res.data;
        }
      });
    },
    saleAdd() {
      this.addDialogSale = true;
      this.formDataSale = this.$options.data().formDataSale;
      setTimeout(() => {
        this.$refs.reffromDataSale.resetFields();
      }, 100);
    },
    //销售订单  --结束 --
    setSignature(item) {
      console.log(this.look4form);
      const selectedUser = this.userList.find(u => u.id === item);
      if (selectedUser) {
        this.look4form.signerId01 = selectedUser.name;
        this.look4form.signerSignature = selectedUser.signatureImg;
      }
    },
    setCheckOneSignature(item) {
      // this.look4form.checkOneSignature = item.signatureImg;
      const selectedUser = this.userList.find(u => u.id === item);
      if (selectedUser) {
        this.look4form.checkOneId01 = selectedUser.name;
        this.look4form.checkOneSignature = selectedUser.signatureImg;
      }
    },
    confirmReport(selectReportId, selectReport) {
      if (this.reportType == 1) {
        this.look4Table[this.reportIndex].cjcz = selectReportId;
        this.look4Table[this.reportIndex].cjczName = selectReport.reportCode;
      }
      if (this.reportType == 2) {
        this.look4Table[this.reportIndex].hgz = selectReportId;
        this.look4Table[this.reportIndex].hgzName = selectReport.reportCode;
      }
      if (this.reportType == 3) {
        this.look4Table[this.reportIndex].dsf = selectReportId;
        this.look4Table[this.reportIndex].dsfName = selectReport.reportNo;
      }
      this.reportDig = false;
    },
    choiceReport(index, type, text) {
      this.reportIndex = index;
      this.reportType = type;
      this.$refs.ReportDig.choiceReport(index, type, text);
      this.reportDig = true;
    },
    //批量排除
    excluse() {
      this.$confirm("此操作将排除该数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          let idArr = [];
          this.tableDataSelect.forEach(item => {
            idArr.push(item.id);
          });
          batchExclude(idArr).then(res => {
            if (res.code == 1001) {
              this.gettableData();
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    reload() {
      this.gettableData();
    },
    submit4() {
      // console.log(this.$refs.checkOneId0.getCheckedNodes()[0].data);
      this.$refs.look4form.validate(valid => {
        if (valid) {
          let idListArr = this.idList.map(res => res.id);
          this.look4form.idList = idListArr;
          this.look4form.reportIdList = [];
          this.look4form.threeReportIdList = [];
          this.look4Table.forEach(item => {
            if (item.cjcz) {
              this.look4form.reportIdList.push(item.cjcz);
            }
          });
          this.look4Table.forEach(item => {
            if (item.hgz) {
              this.look4form.reportIdList.push(item.hgz);
            }
            if (item.dsf) {
              this.look4form.threeReportIdList.push(item.dsf);
            }
          });
          // this.look4form.signerSignature = this.imageUri + this.look4form.signerSignature;
          // this.look4form.checkOneSignature = this.imageUri + this.look4form.checkOneSignature;
          this.$Download(this.exportTende, this.look4form);
        }
      });
    },
    choose(num) {
      this.currenindex = num;
      // this.tableParam.status = this.currenindex
      // this.gettableData();
    },
    submit3() {
      this.$refs.look3form.validate(valid => {
        if (valid) {
          console.log(JSON.parse(JSON.stringify(this.look3form)));
          this.tableDataSelect.map(v => {
            v.orderId = v.id;
          });
          console.log(JSON.parse(JSON.stringify(this.tableDataSelect)));
          this.look3form.startTime = "";
          this.look3form.endTime = "";
          if (this.look3form.time.length > 0) {
            this.look3form.startTime = this.look3form.time[0];
            this.look3form.endTime = this.look3form.time[1];
          }
          let json = {
            handOverData: this.look3form,
            handOverPlans: this.tableDataSelect,
          };
          handOverInformationsaveResord(json).then(res => {
            if (res.code == 1001) {
              this.$message({
                message: "交工资料生成成功！",
                type: "success",
              });
              this.look3Type = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    look3Fun() {
      const newData = this.tableDataSelect.map(item => item.engineeringId);
      if ([...new Set(newData)].length !== 1) {
        this.$message.warning("生成交工资料的工程必须相同，请重新选择");
        return;
      }
      this.look3Type = true;
      this.look3form.engineeringName = this.tableDataSelect[0].engineeringName;
      this.look3form.engineeringId = this.tableDataSelect[0].engineeringId;
    },
    // prinDeriveFun(e) {
    //   const newData = this.tableDataSelect.map(item => item.engineeringId);
    //   if ([...new Set(newData)].length !== 1) {
    //     this.$message.warning("导出开盘资料的工程必须相同，请重新选择");
    //     return;
    //   }
    //   // 默认写死检测人，签发人、校核人
    //   if (this.look4form.inspectorSignatureList.length == 0) {
    //     this.look4form.inspectorSignatureList = ["赵兴阳", "何元进"];
    //   }
    //   this.look4form.signerId0 = ["77961511896748032"];
    //   this.look4form.signerId01 = "胡江";
    //   this.look4form.signerSignature = "group1/M01/4F/BF/ChQACmnDTOyAaFtQAAAONFOzvU8333.png";
    //   this.look4form.checkOneId0 = ["60547412053331968"];
    //   this.look4form.checkOneId01 = "王玮";
    //   this.look4form.checkOneSignature = "group1/M00/0E/19/ChQACmUwzJWAN7OyAAAdDsa_IyM527.png";
    //   let idArr = [];
    //   this.tableDataSelect.forEach(v => {
    //     idArr.push(v.id);
    //   });
    //   getRawName(idArr).then(res => {
    //     if (res.code == 1001) {
    //       this.look4Table = res.data;
    //       this.look4Type = true;
    //       this.idList = [];
    //       this.tableDataSelect.forEach(v => {
    //         this.idList.push({ id: v.id, type: e });
    //       });
    //     }
    //   });
    // },
    prinDeriveFun(e) {
      const newData = this.tableDataSelect.map(item => item.engineeringId);
      if ([...new Set(newData)].length !== 1) {
        this.$message.warning("导出开盘资料的工程必须相同，请重新选择");
        return;
      }

      // 1. 确保检测人有默认值（已存在）
      if (this.look4form.inspectorSignatureList.length == 0) {
        this.look4form.inspectorSignatureList = ["赵兴阳", "何元进"];
      }
      const signer = this.userList.find(u => u.name && u.name.trim() === '胡江');
      const checker = this.userList.find(u => u.name && u.name.trim() === '王玮');

      // 1. 绑定 ID (触发下拉框回显)
      this.$set(this.look4form, 'signerId0', signer ? signer.id : '');
      this.$set(this.look4form, 'checkOneId0', checker ? checker.id : '');
      // 2. 绑定 姓名 (业务逻辑需要的字段)
      this.look4form.signerId01 = signer ? signer.name : '';
      this.look4form.checkOneId01 = checker ? checker.name : '';
      // 3. 绑定 签名图片
      this.look4form.signerSignature = signer ? signer.signatureImg : "";
      this.look4form.checkOneSignature = checker ? checker.signatureImg : "";
      let idArr = this.tableDataSelect.map(v => v.id);
      // 先把弹窗打开，Vue 就会去读取此时的 look4form
      this.look4Type = true; 

      getRawName(idArr).then(res => {
        if (res.code == 1001) {
          this.look4Table = res.data;
          this.idList = this.tableDataSelect.map(v => ({ id: v.id, type: e }));
        }
      });

      // 如果你一定要在打印查看，请使用 JSON 序列化查看，否则浏览器打印的是引用地址
      console.log("最终赋值后的 look4form:", JSON.parse(JSON.stringify(this.look4form)));
    },
    list1SelectionFun(val) {
      this.tableDataSelect = val;
    },
    /*重置数据*/
    init() {
      const today = moment().add(1, "days").format("YYYY-MM-DD 00:00:00"); //当前日期
      const weekBefore = moment().subtract(7, "days").format("YYYY-MM-DD 00:00:00"); // 近七日日期
      this.tableParam.startQueryTime = weekBefore;
      this.tableParam.endQueryTime = today;
      this.startTimDateEndTimDate = [weekBefore, today];
      this.tableParam.productName = "";
      this.tableParam.status = "";
      this.tableParam.stationIdList = [];
      this.tableParam.mixRatioDeployStatus = "";
      this.tableParam.engineeringId = "";
      this.tableParam.structuralParts = "";
      this.gettableData();
    },
    open(key, low) {
      this.dialog1 = true;
      signOfPrintLog({ id: low.id }).then(res => {
        this.tableParam1.total1 = res.data.totalRows;
        this.table1 = res.data.data;
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
  mounted() {
    queryEngineeringList().then(res => {
      this.engineeringIdList = res.data;
      this.gettableData();
    });
  },
};
</script>

<style lang="scss" scoped>
.dialogOtherinfo {
  .el-pagination {
    padding: 10px 0;
  }
  .form-title {
    font-size: 18px;
    margin: 10px 0;
  }
}
.el-input,
.el-select {
  width: 240px;
}
/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
